import { GcpBox, GcpCurrencyFormat, GcpTypography } from '@back-office/ui';
import { Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCardStyles from './styles';

interface TransactionAmountProps {
  currency: string;
  amount: string;
  transferAmount: string | null;
  statusLabel: string;
  isVoided: boolean;
}

const TransactionAmount: FC<TransactionAmountProps> = (props) => {
  const { currency, amount, transferAmount, statusLabel, isVoided } = props;
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('lg'));
  const classes = useCardStyles();

  return (
    <Grid
      container
      className={clsx(classes.card, { [classes.root]: matches })}
      justify="center"
    >
      <Grid
        item
        className={clsx(classes.items, { [classes.amount]: !matches })}
        lg={4}
        xs={12}
      >
        <GcpCurrencyFormat
          align="center"
          suffix={currency}
          value={amount}
          valueVariant="h2"
        />
        <GcpTypography paint="ceriseRed" textAlign="center" variant="body1">
          {t('transaction_list.amount')}
        </GcpTypography>
        {!matches && <Divider className={classes.divider} />}
      </Grid>
      <Grid
        item
        className={clsx(classes.items, { [classes.amount]: !matches })}
        lg={4}
        xs={12}
      >
        <GcpCurrencyFormat
          align="center"
          suffix={currency}
          value={transferAmount}
          valueVariant="h2"
        />
        <GcpTypography paint="ceriseRed" textAlign="center" variant="body1">
          {t('transaction_list.transfer_amount')}
        </GcpTypography>
        {!matches && <Divider className={classes.divider} />}
      </Grid>
      <Grid
        item
        className={clsx({ [classes.amount]: !matches })}
        lg={4}
        xs={12}
      >
        <GcpBox
          alignItems="center"
          display="flex"
          gap={1}
          justifyContent="center"
        >
          <GcpTypography textAlign="center" transform="capitalize" variant="h2">
            {statusLabel}
          </GcpTypography>
          {isVoided && (
            <GcpBox className={classes.alert} textAlign="center">
              <GcpTypography
                paint="torchRed"
                transform="capitalize"
                variant="caption"
              >
                {t('transaction_list.voided')}
              </GcpTypography>
            </GcpBox>
          )}
        </GcpBox>
        <GcpTypography paint="ceriseRed" textAlign="center" variant="body1">
          {t('transaction_list.header.status')}
        </GcpTypography>
      </Grid>
    </Grid>
  );
};

export default TransactionAmount;
